export default {
    tracking: {
        storyName: 'Tschernobyl Block 4',
        storyID: '3D Story-Tschernobyl',
    },
    babylon: {
        lightIntensity : 2,
        minCamRadius : 10,
        maxCamRadius :300,
        panSensibility: 0, // 0 is deactivated
        backgroundRed : 223/255, //45/255,  
        backgroundGreen : 224/255, //55/255,
        backgroundBlue : 221/255, //70/255,
        //backgroundRed : 45/255,  
        //backgroundGreen : 55/255,
        //backgroundBlue : 70/255,
        //backgroundHex: "#2D3746",  //dunkelblau: #dfe0dd   grau: #2D3746
        // Funktionen aus dem Babylon Controller, die per babylonState gesetzt werden können.
        functionDefaults: {
            setAnimationSpeed: [180],
            moveCamera: [.5 * Math.PI, .5 * Math.PI, 20, 0, 5, 0]
        }
    },
    objects:
    [
        {
            name: "Geo_Tschernobyl",
            filename: "Tschernobyl.glb",
            //filename: require("./assets/3d-models/NotreDame_FInalBaked_Maya_CD_191126_001_hg.glb"),
            //filename: "200324_NotreDameStory_hg_v002.glb",
            options: {
                //// BaseObject
                // true: Objekt anzeigen
                visible: true,
                // Skalierung: Objekt Größe ändern in allen Dimensionen
                scaling: [1, -1, 1],
                // Skalierung: Objekt Größe ändern (Alle Dimensionen gleich)
                //scale: 0.01,
                // Position
                position: [0, -0, 0],
                // Rotation
                // rotation: [0, 0, 0],
                // Rotation Quaternion, siehe https://doc.babylonjs.com/features/position,_rotation,_scaling#rotationquaternion
                rotationQuaternion: [0.7071068, 0, 0, 0.7071068],
                // Transparenz (0 bis 1)
                //visibility: 0.25,
                // RGB-Farbe (diffuse) jeweils Werte 0 bis 255
                //diffuse: [255, 0, 0],

                //// MeshObject
                // Objekt mit Fade ein und ausblenden, wenn visible sich ändert
                fade: true,
                // Unter-Mesh-Objekte in der Datei
                children: {
                    // Name des Meshs wie im 3D Model
                    BG_Sphere: false,
                    Geo_Beton_Sarkophag_Rost: false,
                    Geo_Schattenplane_Betonsarkophag: false,
                    Geo_Beton_Sarkophag: false,
                    Geo_Neuer_Sarkophag: false,
                    Geo_Neuer_Sarkophag_anim: false,
                    Geo_Neuer_Sarkophag_endpos: false,
                    Geo_Neuer_Sarkophag_endpos_transparent: false,
                    Geo_Neuer_Sarkophag_startpos: false,
                    Geo_Neuer_Sarkophag_startpos_transparent: false,
                    Geo_Textur1_Reaktor_4_unversehrt: false,
                    Geo_Textur1_Reaktor_4_Damage: true,
                    Geo_Textur1_Reaktor_4_Damage_Aussen: true,
                    Geo_Textur1_Reaktor_4_Damage_Innen: true,
                    Geo_Schienen_Sarkophag: false,
                    Geo_Typo_1: false,
                    Geo_Typo_2: false,
                    Geo_Typo_3: false,
                    Geo_Typo_4: false,
                    Geo_Typo_Reaktor: false,
                    Geo_Typo_1986_Oben: false,
                    Geo_Typo_1986_Mitte: false,
                    Geo_Typo_1986_Unten: false,
                    Geo_Typo_2016: false,

                    Geo_KleinerTurm_Geruest1: false,
                    Geo_KleinerTurm_RoteStreifen1: false,
                    Geo_KleinerTurm_Schlot1: false,
                    Geo_KleinerTurm_Schattenplane: false,
                    
                    Geo_Elbphilharmonie_Glas: false,
                    Geo_Elbphilharmonie_Basis: false,
                    Geo_Elbphilharmonie_Dach: false,
                    Geo_Elbphilharmonie_Mitte: false,
                    Geo_Elbphilharmonie_Sockel: false,

                    Geo_Schattenplane_NSC: false,
                    Geo_Schattenplane_NSC_anim: false,
                    Geo_Schattenplane_NSC_startpos: false,

                    Geo_Sperrzone: false,
                    Geo_Text_Sperrzone: false,


                    
                    Geo_Pfeil_108m: false,
                    Geo_Pfeil_162m: false,
                    Geo_Pfeil_257m: false,
                    Geo_Typo_108m: false,
                    Geo_Typo_162m: false,
                    Geo_Typo_275m: false,
                    
                    Strahl_1: false,
                    Strahl_2: false,

                },
                
                //// BabylonObject
                // animation=true: startet die Animation im Objekt
                animation: false,

                // Nur initial, nicht per babylonState
                // OnClick Trigger
                // trigger: function () { }
            },
            // Callback wenn Objekt geladen und erstellt wurde zum setzen weiterer Einstellungen.
            callback: function (Geo_Tschernobyl) // eslint-disable-line no-unused-vars
            {

                let MAT_Strahl = this.scene.getNodeByName('Strahl_2').material;
                MAT_Strahl.albedo = [0, 0.4, 1];
               MAT_Strahl.emission = [0, 0.4, 1];
                MAT_Strahl.alpha = 0.5;
                MAT_Strahl.albedoTexture.hasAlpha = true;
                MAT_Strahl.alphaMode = 1;
                MAT_Strahl.transparencyMode = 2;

                let MAT_Sarkophag = this.scene.getNodeByName('Geo_Neuer_Sarkophag_startpos_transparent').material;
                //MAT_Sarkophag.diffuse = [0, 0, 0];
                //MAT_Sarkophag.emissive = [0, 0.4, 1];
                MAT_Sarkophag.alpha = 0.5;  //0.2
                MAT_Sarkophag.albedoTexture.hasAlpha = true;
                MAT_Sarkophag.alphaMode = 2; //1
                MAT_Sarkophag.backFaceCulling = 1; //1
                MAT_Sarkophag.transparencyMode = 2; //2

                
                let MAT_Sperrzone = this.scene.getNodeByName('Geo_Sperrzone').material;
                //MAT_Sarkophag.diffuse = [0, 0, 0];
                //MAT_Sarkophag.emissive = [0, 0.4, 1];
                MAT_Sperrzone.alpha = .3;
                MAT_Sperrzone.alphaMode = 2;
                //MAT_Sperrzone.disableLighting = true,
                //MAT_Sperrzone.backFaceCulling = 1;
                MAT_Sperrzone.transparencyMode = 2;


                let MAT_BGSphere = this.scene.getNodeByName('BG_Sphere').material;
                MAT_BGSphere.disableLighting = true;
                MAT_BGSphere.alpha = 1;

                let MAT_Orange = this.scene.getNodeByName('Geo_Typo_2016').material;
                MAT_Orange.disableLighting = true;

                let MAT_Weiss = this.scene.getNodeByName('Geo_Typo_1').material;
                MAT_Weiss.disableLighting = true;

                let MAT_Truemmer = this.scene.getNodeByName('Debris_3').material;
                MAT_Truemmer.disableLighting = false;

                let MAT_Typo_Sperrzone = this.scene.getNodeByName('Geo_Text_Sperrzone').material;
                MAT_Typo_Sperrzone.disableLighting = true;
                
                let MAT_SarkophagSchatten = this.scene.getNodeByName('Geo_Schattenplane_Betonsarkophag').material;
                MAT_SarkophagSchatten.alpha = .9;
                //MAT_Sarkophag.albedoTexture.hasAlpha = true;

                /*
                let mat_Geo_Geruest_marked = this.scene.getNodeByName('Geo_Geruest_marked').material;
                mat_Geo_Geruest_marked.transparencyMode = 1;
                mat_Geo_Geruest_marked.albedoTexture.hasAlpha = true;
                */
            },
        },
        // Dies koennte ein zweites Objekt sein, das ihr ladet.
        
        {
            name: "Geo_Explosion",
            filename: "Explosion_Tschernobyl_200329.glb",
            //filename: require("./assets/3d-models/PlatteNotreDame.glb"),
            options: {
                visible: false,
                position: [12.5, 0, 0],
                scaling: [0.06,-0.06,0.06],
                rotationQuaternion: [0.7071068, 0, 0.7071068, 0],
                children: {
					Reaktor_ZumPositionieren: true,
					//Piece_3_2Shape_Debris_Instancer_59: false,				
                },
                animation: false,
             },
             callback: function (Geo_Explosion) // eslint-disable-line no-unused-vars
             {
                 //let MAT_Truemmer = this.scene.getNodeByName('Debris_3').material;
                 //MAT_Truemmer.diffuse = [255, 255,255];
                 //MAT_Truemmer.emissive = [255, 255, 255];
                 //MAT_Truemmer.alpha = 0.5;
                 //MAT_Truemmer.albedoTexture.hasAlpha = true;
                 //MAT_Truemmer.alphaMode = 1;
                 //MAT_Truemmer.transparencyMode = 2;
             },
        },
    ]
};